import { UnitType } from '@exodus/currency'

const name = 'nem'
const displayName = 'NEM'
const ticker = 'XEM'
const displayTicker = 'XEM'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#6E68A5'
const gradientColors = ['#6E68A5', '#7D68A5']
const gradientCoords = { x1: '-22.982%', y1: '-43.915%', x2: '91.53%', y2: '101%' }
const chainBadgeColors = gradientColors

const units = {
  uXEM: 0,
  XEM: 6,
}
const currency = UnitType.create(units)

const assetType = 'OTHER'
const blockExplorer = {
  addressUrl: (address) =>
    `https://explorer.nemtool.com/#/s_account?account=${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://explorer.nemtool.com/#/s_tx?hash=${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'NEM is a smart asset and blockchain platform. Its multi-tier design and APIs make it both secure and easy to build on for developers.',
  reddit: 'https://www.reddit.com/r/nem/',
  twitter: 'https://twitter.com/nemofficial/',
  website: 'https://nem.io/',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
